import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3412">
      <Navbar data-id="element-3413" />
      <main data-id="element-3414">
        <ConsularAffairs data-id="element-3415" />
      </main>
      <Footer data-id="element-3416" />
      <FeedbackPopup data-id="element-3417" />
    </div>;
}